import { useMemo } from "react";
import type { DocumentNode } from "@apollo/client";
import { useEventsBasePath } from "../_eventsBasePathContext";
import {
  EVENT_QUERY as ATTENDANCE_EVENT_QUERY,
  UNIVERSITY_ATTENDANCE_EVENT_QUERY
} from "./(tabbed)/attendance/queries";
import { EVENT_QUERY, UNIVERSITY_EVENT_QUERY } from "./queries";

export function useIsUniversityEventsRoute() {
  const basePath = useEventsBasePath();
  return basePath.startsWith("/education/universities/");
}

export function useEventDetailQueryDocument(): DocumentNode {
  const isUniversityEventsRoute = useIsUniversityEventsRoute();

  return useMemo(() => (isUniversityEventsRoute ? UNIVERSITY_EVENT_QUERY : EVENT_QUERY), [isUniversityEventsRoute]);
}

export function useAttendanceEventQueryDocument(): DocumentNode {
  const isUniversityEventsRoute = useIsUniversityEventsRoute();

  return useMemo(
    () => (isUniversityEventsRoute ? UNIVERSITY_ATTENDANCE_EVENT_QUERY : ATTENDANCE_EVENT_QUERY),
    [isUniversityEventsRoute]
  );
}
